module.exports = __webpack_public_path__ + "static/img/h3.4e5e5ebe.png";